export const EVENT_DETAILS = 'EVENT_DETAILS';
export const EVENT_LIST = 'EVENT_LIST';
export const EVENT_STORE_LIST = 'EVENT_STORE_LIST';
export const ERROR_PAGE = 'ERROR_PAGE';
export const REGISTER = 'REGISTER';
export const SUCCESS = 'SUCCESS';
export const SELF_CHECKIN = 'SELF_CHECKIN';
export const SELF_CHECKIN_THANKYOU = 'SELF_CHECKIN_THANKYOU';
